import { render, staticRenderFns } from "./PartyBottomSheetNavigation.vue?vue&type=template&id=3c56c865&scoped=true"
import script from "./PartyBottomSheetNavigation.vue?vue&type=script&lang=js"
export * from "./PartyBottomSheetNavigation.vue?vue&type=script&lang=js"
import style0 from "./PartyBottomSheetNavigation.vue?vue&type=style&index=0&id=3c56c865&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c56c865",
  null
  
)

export default component.exports